import {
  AfterViewChecked,
  Component,
  ElementRef,
  computed,
  input,
  linkedSignal,
  viewChild,
} from '@angular/core';

import { agruparMensajesPorFecha } from '../../../helpers/chat-fecha';
import { ChatMensaje, ChatPerspectiva } from '../../../interfaces/chat.interface';

const LOTE_MENSAJES = 20;
const UMBRAL_CARGA_PX = 80;

@Component({
  selector: 'app-chat-messages',
  standalone: true,
  templateUrl: './chat-messages.component.html',
  styleUrl: './chat-messages.component.scss',
})
export class ChatMessagesComponent implements AfterViewChecked {
  readonly mensajes = input<ChatMensaje[]>([]);
  readonly perspectiva = input<ChatPerspectiva>('admin');

  private readonly contenedor = viewChild<ElementRef<HTMLElement>>('contenedor');

  /** Cuantos mensajes del final estan en pantalla. Al subir se suman de a 20. */
  private readonly ventana = linkedSignal({
    source: () => this.mensajes()[0]?.id ?? '',
    computation: () => LOTE_MENSAJES,
  });

  private claveChat = '';
  private ultimoId = '';
  private anclarAlFinal = true;
  private ajustar: { alto: number; top: number } | null = null;

  readonly visibles = computed(() => {
    const todos = this.mensajes();
    return todos.slice(Math.max(0, todos.length - this.ventana()));
  });

  readonly grupos = computed(() => agruparMensajesPorFecha(this.visibles()));

  readonly hayAnteriores = computed(() => this.mensajes().length > this.visibles().length);

  readonly tipoPropio = computed(() => (this.perspectiva() === 'admin' ? 'admin' : 'solicitud'));

  ngAfterViewChecked(): void {
    const elemento = this.contenedor()?.nativeElement;
    if (!elemento || elemento.clientHeight === 0) {
      return;
    }

    const todos = this.mensajes();
    const clave = todos[0]?.id ?? '';
    const ultimo = todos.at(-1)?.id ?? '';
    if (clave !== this.claveChat) {
      this.claveChat = clave;
      this.ultimoId = ultimo;
      this.anclarAlFinal = true;
      this.ajustar = null;
    } else if (ultimo !== this.ultimoId) {
      this.ultimoId = ultimo;
      this.anclarAlFinal = true;
    }

    if (this.ajustar) {
      const { alto, top } = this.ajustar;
      this.ajustar = null;
      elemento.scrollTop = elemento.scrollHeight - alto + top;
      return;
    }

    if (!this.anclarAlFinal) {
      return;
    }

    elemento.scrollTop = elemento.scrollHeight;
    if (elemento.scrollHeight <= elemento.clientHeight && this.hayAnteriores()) {
      this.ventana.update((actual) => actual + LOTE_MENSAJES);
      return;
    }
    this.anclarAlFinal = false;
  }

  alDesplazar(): void {
    const elemento = this.contenedor()?.nativeElement;
    if (!elemento || this.ajustar || this.anclarAlFinal || !this.hayAnteriores()) {
      return;
    }
    if (elemento.scrollTop > UMBRAL_CARGA_PX) {
      return;
    }
    this.ajustar = { alto: elemento.scrollHeight, top: elemento.scrollTop };
    this.ventana.update((actual) => actual + LOTE_MENSAJES);
  }
}
